import React, { useEffect } from 'react';
import { CustomerGroup } from '../../types/data';
import { useTranslation } from 'react-i18next';

interface Props {
  customerGroups: CustomerGroup[];
  selectedGroup: string;
  onSelect: (groupName: string) => void;
}

export const CustomerGroupSelector: React.FC<Props> = ({
  customerGroups,
  selectedGroup,
  onSelect,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (customerGroups && customerGroups.length > 0 && !selectedGroup) {
      onSelect(customerGroups[0].name);
    }
  }, [customerGroups, selectedGroup, onSelect]);

  return (
    <>
      <label htmlFor="customer-group-select" className="block text-gray-700">
        {t('common.target_customer_group')}:
      </label>
      <select
        id="customer-group-select"
        value={selectedGroup}
        onChange={(e) => onSelect(e.target.value)}
        className="mt-2 block w-full p-2 border rounded-md"
      >
        <option value="">{t('category.select_customer_group')}</option>
        {customerGroups.map((group) => (
          <option key={group.name} value={group.name}>
            {group.name}
          </option>
        ))}
      </select>
      {(!customerGroups || customerGroups.length === 0) && (
        <div className="mt-2 text-red-600 text-sm">{t('ads.no_customer_target_groups')}</div>
      )}
    </>
  );
};
